module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AUTHORS’ NOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("M")]), _vm._v("any Welsh place names were spelt in two or more ways especially during the nineteenth century, e.g. Pantywaen or Pantywaun or Pant-y-Waun. We have used either/all the different spellings in this book so the reader has a flavour of the diversity. This also applied to people’s names e.g. Ifor or Ivor Works at Dowlais.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0007-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Dowlais based TV 04 333 with a service to Pant or Pontsticill awaiting departure on 12 August 1939. ("), _c('span', {
    staticClass: "fn-1"
  }, [_vm._v("F.K. Davies")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89e43506","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Authors-Note.vue
// module id = 75
// module chunks = 0